import { formatDate } from "@/composables/formatUtils";
import type { DeliveryResponse } from "@/forwards2/forwardsTypes";
import { useI18n } from "vue-i18n";

/**
 * How a delivery window reads on the deal page: "on or before <end>" for an open-ended delivery,
 * otherwise the dated span. Callers keep their own guard for a delivery that may be missing.
 */
export const useDeliveryWindowText = () => {
  const { t } = useI18n();
  return (
    delivery: Pick<
      DeliveryResponse,
      "delivery_window_start" | "delivery_window_end"
    >
  ): string =>
    delivery.delivery_window_start === null
      ? t("forwards.deals.plan.window_on_or_before", {
          end: formatDate(delivery.delivery_window_end),
        })
      : t("forwards.deals.plan.window_range", {
          start: formatDate(delivery.delivery_window_start),
          end: formatDate(delivery.delivery_window_end),
        });
};
